function tableCellWidth() {
  function buildColGroupAndSetTableWidth(table) {
    let wrapper: HTMLElement;
    if (table.parentElement?.classList.contains('table-wrapper')) {
      wrapper = table.parentElement;
    } else {
      wrapper = document.createElement('div');
      wrapper.className = 'table-wrapper';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    const firstRow = table.rows[0];
    const colgroup = document.createElement('colgroup');

    let totalWidth = 0;
    let hasZeroWidth = false;

    for (let cell of firstRow.cells) {
      const colspan = parseInt(cell.getAttribute('colspan') || 1);
      const widths = (cell.dataset.colwidth || '').split(',');

      for (let i = 0; i < colspan; i++) {
        const width = parseInt(widths[i]) || 0;

        const col = document.createElement('col');

        if (width > 0) {
          col.style.width = width + 'px';
          totalWidth += width;
        } else {
          col.style.minWidth = '1px'; // fallback minimal width
          hasZeroWidth = true;
        }

        colgroup.appendChild(col);
      }
    }

    // Remove existing colgroup if present
    const existing = table.querySelector('colgroup');
    if (existing) existing.remove();

    table.insertBefore(colgroup, table.firstChild);

    // Apply total width to table
    if (hasZeroWidth) {
      table.style.minWidth = totalWidth + 'px';
      table.style.width = '';
    } else {
      table.style.width = totalWidth + 'px';
      table.style.minWidth = '';
    }
  }

  Array.from(document.querySelectorAll('table')).forEach(
    (tableElement: HTMLTableElement) => {
      buildColGroupAndSetTableWidth(tableElement);
    },
  );
}

window.tableCellWidth = tableCellWidth;
